import { makeGetData } from '@pes-ui/components/dist/collection/globals/http';
import { consoleErrorMsg } from '@pes-ui/utils';
import { name, version } from '../../package.json';
import { RecentlyViewService } from '../services/recently-viewed';
import { TRecentlyViewProducts } from './gloabal-types';
import { expAPIEndpoint, getExpAPIEndpointURL } from './utils/exp-api-urls-builder';
import pesCLValidator from './utils/pes-country-language-validation/pes-country-language-validation';

// Global visibility
window['pes'] = window['pes'] || {};
window['pes']['validateCountryLanguage'] = pesCLValidator;

export const getData = makeGetData(name, version);
export const MAX_RECENTLY_VIEW_PRODUCTS = 16;
export const FILTER_QUERY_PARAM ='filter'
export const BREADCRUMBS_ITEM_TYPE = ['SITE', 'BUSINESS']

export const requestRecentlyViewedProducts = async (maxProducts, sectionTitle) : Promise<TRecentlyViewProducts>   => {
    const recentlyViewService: RecentlyViewService = RecentlyViewService.getInstance( 
        getExpAPIEndpointURL(expAPIEndpoint.PRODUCT_CARD_SPRYKER), 
        maxProducts 
    );
    try {
        const res = await recentlyViewService.getProducts('');
        return {
            sectionTitle: sectionTitle,
            data: res,
            versionLabel: '',
        };
    } catch(err) {
        consoleErrorMsg(err, 'product-card api failed');
    };
}
